import { render, staticRenderFns } from "./Loading.vue?vue&type=template&id=e41fac9c&lang=pug"
import script from "./Loading.vue?vue&type=script&lang=coffee"
export * from "./Loading.vue?vue&type=script&lang=coffee"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports